import { useEffect, useState } from 'react';
import { loadMasterMeta } from '../lib/masterRoles';

/* useRoleCount — returns dynamic preview count from master-roles-meta.json.
   Defaults to null while loading so callers can render a graceful fallback. */
export const useRoleCount = () => {
  const [count, setCount] = useState(null);
  useEffect(() => {
    let alive = true;
    loadMasterMeta().then((m) => {
      if (alive && m?.total_previews) setCount(m.total_previews);
    });
    return () => { alive = false; };
  }, []);
  return count;
};
